// extracted by mini-css-extract-plugin
export default {"header":"tokenForm_header__Aeenl","header_text":"tokenForm_header_text__XUBC+","buttons":"tokenForm_buttons__ZKCJW","spinner":"tokenForm_spinner__9wGTq"};